import { createFileRoute, redirect } from '@tanstack/react-router';

import { travelHomeFor } from '@/module/Travel/travelRoles';

import { useCurrentUserStore } from '@feature/security';

export const Route = createFileRoute('/_auth/travel/_travel/')({
  beforeLoad: ({ preload }) => {
    if (!preload) {
      throw redirect({ to: travelHomeFor(useCurrentUserStore.getState().currentUser?.currentRole), replace: true });
    }
  },
});
